// import React from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import styles from "./GarageCard.module.css";

function getContrastTextColor(bgColor) {
    const color = bgColor.toLowerCase();
    const lightColors = ["white", "yellow", "beige", "silver", "ivory", "lightgray", "lightblue", "lightgreen"];
    if (lightColors.includes(color)) return "#222";
    return "#fff";
}

const statusLabels = {
    1: "Checked In",
    2: "Staged",
    3: "Parked",
    4: "Requested",
    5: "Retrieved",
    6: "Checked Out",
};

const statusClassMap = {
    1: styles.themeCheckedIn,
    2: styles.themeStaged,
    3: styles.themeParked,
    4: styles.themeRequested,
    5: styles.themeRetrieved,
    6: styles.themeCheckedOut,
};

function formatChargeAmount(amountDueCents, isPaid = false) {
    const normalized = Number(amountDueCents || 0);
    if (!Number.isFinite(normalized) || normalized <= 0) return `${isPaid ? "Paid" : "Charge"}: --`;
    const amount = `$${(normalized / 100).toFixed(2)}`;
    return `${isPaid ? "Paid" : "Charge"}: ${amount}`;
}

const GarageCard = ({ garageData, paymentByVehicleId = {}, readOnly = false, paymentsEnabled = true }) => (
    <div className={styles.garageCardGrid}>
        {garageData.map((vehicle, idx) => {
            const bgColor = vehicle.vehicleColor || "gray";
            const textColor = getContrastTextColor(bgColor);
            const statusThemeClass = statusClassMap[vehicle.vehicleStatusId] || styles.themeOther;
            const paymentStatus = paymentByVehicleId?.[vehicle.vehicleId] || null;

            const amountDueCents = Number(paymentStatus?.amountDueCents || 0);
            const hasChargeAmount = Number.isFinite(amountDueCents) && amountDueCents > 0;
            const validatedAmountCents = Number(paymentStatus?.validatedAmountCents || 0);
            const hasValidation = Number.isFinite(validatedAmountCents) && validatedAmountCents > 0;
            const isPaid = Boolean(paymentStatus?.paymentStatus === "paid" || paymentStatus?.isPaid);
            const chargeClassName = hasChargeAmount ? (isPaid ? styles.paymentPaid : styles.paymentUnpaid) : styles.paymentFree;
            const isPaymentUnavailable = Boolean(paymentsEnabled && paymentStatus?.loadState === "error");
            const shouldShowPaymentBadge = Boolean(paymentsEnabled && (hasChargeAmount || isPaymentUnavailable));
            const showPaymentBadge = shouldShowPaymentBadge;
            const chargeLabel = paymentsEnabled ? (isPaymentUnavailable ? "Payment unavailable" : formatChargeAmount(amountDueCents, isPaid)) : "";
            const spotLabel = vehicle.parkingSpot ? `Spot: ${vehicle.parkingSpot}` : "Spot: --";
            const transferLabel = vehicle.hasPendingTransfer ? "Transfer Pending" : "Transfer: --";

            return (
                <div
                    className={styles.garageCardTile}
                    key={vehicle.id || idx}>
                    <Link
                        to={readOnly ? "#" : `/transactions/id/${vehicle.vehicleId}`}
                        onClick={(event) => {
                            if (readOnly) event.preventDefault();
                        }}
                        aria-disabled={readOnly}
                        tabIndex={readOnly ? -1 : undefined}
                        className={styles.garageCardLink}>
                        <Button
                            disabled={readOnly}
                            className={`${styles.garageCardTicket} ${statusThemeClass}`}
                            style={{
                                backgroundColor: bgColor,
                                color: textColor,
                                opacity: readOnly ? 1 : undefined,
                            }}>
                            <h5
                                className={styles.ticketValue}
                                style={{ color: textColor }}>{`${vehicle.vehicleTicketNum.toString().slice(-4)}`}</h5>
                            <p
                                className={styles.makeValue}
                                style={{ color: textColor }}>
                                {(vehicle.vehicleMake || "Not set").slice(0, 12)}
                            </p>
                            <p className={`${styles.spotPill} ${!vehicle.parkingSpot ? styles.infoPlaceholder : ""}`}>{spotLabel}</p>
                            <div className={styles.statusInfo}>
                                <span className={styles.statusBadge}>{statusLabels[vehicle.vehicleStatusId] || "Unknown"}</span>
                                <span
                                    className={`${styles.transferBadge} ${!vehicle.hasPendingTransfer ? styles.slotHidden : ""}`}
                                    aria-hidden={!vehicle.hasPendingTransfer}>
                                    {transferLabel}
                                </span>
                                <span
                                    className={`${styles.paymentBadge} ${chargeClassName} ${!showPaymentBadge ? styles.slotHidden : ""}`}
                                    aria-hidden={!showPaymentBadge}>
                                    {chargeLabel}
                                </span>
                                {hasValidation ? <span className={`${styles.paymentBadge} ${styles.paymentPaid}`}>{`Validated: $${(validatedAmountCents / 100).toFixed(2)}`}</span> : null}
                            </div>
                        </Button>
                    </Link>
                </div>
            );
        })}
    </div>
);

export default GarageCard;
